import AsyncStorage from '@react-native-async-storage/async-storage';
const STORAGE_KEY = '@device_unique_id';

// ID gerado pelo app, NÃO derivado de hardware. Isto é intencional: este id é enviado
// junto da atribuição de anúncios (/instalacao, /evento_conversao), e o Google Play
// proíbe conectar o Advertising ID a identificadores persistentes de device como o
// ANDROID_ID/SSAID. Ler IDFV/ANDROID_ID aqui levaria à rejeição do app no Android.
//
// Timestamp + 2 segmentos aleatórios substituem o Math.random() de 9 dígitos, que
// colidia a 150k installs/mês. Regenera na reinstalação — aceitável: o AppsFlyer trata
// reinstalação sozinho (appsflyer_id); este id é só a chave de join do BI.
function generateInstallId(): string {
  const seg = () => Math.random().toString(36).slice(2, 10);
  return `${Date.now().toString(36)}-${seg()}-${seg()}`;
}

export async function getPersistentDeviceId(): Promise<string> {
  const existingId = await AsyncStorage.getItem(STORAGE_KEY);
  if (existingId) {return existingId;}

  const newId = generateInstallId();
  await AsyncStorage.setItem(STORAGE_KEY, newId);
  return newId;
}
